import { AVAILABLE_BONUSES } from "./../types";
import create from "zustand";

type AppStoreTypes = {
  activeBonus: AVAILABLE_BONUSES;
  setActiveBonus: (value: AVAILABLE_BONUSES) => void;
};

export const useAppStore = create<AppStoreTypes>((set) => ({
  activeBonus: AVAILABLE_BONUSES.Eco,

  setActiveBonus: (value: AVAILABLE_BONUSES) => {
    set({ activeBonus: value });
  },
}));
